module.exports = __webpack_public_path__ + "img/background_responsive.4c7ac13c.png";